// extracted by mini-css-extract-plugin
export default {"duty":"duty__h229d"};